import API from 'common/src/api'
import coreUtils from 'common/src/utils/coreUtils'

let phoneVerificationRequest = null

export function fetchPhoneVerificationRequired(suburbId) {
  const normalizedSuburbId = Number(suburbId)

  window.App = window.App || {}
  // Align with Jobs::PhoneVerificationRequired after REB-3535 (always required).
  window.App.phoneVerificationRequired = true

  if (phoneVerificationRequest) {
    phoneVerificationRequest.abort()
    phoneVerificationRequest = null
  }

  if (!normalizedSuburbId) {
    return null
  }

  phoneVerificationRequest = $.ajax({
    url: '/job_wizard/phone_verification_required',
    dataType: 'json',
    data: { suburb_id: normalizedSuburbId },
  })
    .done((result) => {
      window.App.phoneVerificationRequired = result.phone_verification_required === true
    })
    .fail(() => {
      // Keep always-required behaviour if the suburb check fails to load.
      window.App.phoneVerificationRequired = true
    })
    .always(() => {
      phoneVerificationRequest = null
    })

  return phoneVerificationRequest
}

export function runWhenPhoneVerificationRequiredReady(callback) {
  if (phoneVerificationRequest) {
    phoneVerificationRequest.always(callback)
    return
  }

  callback()
}

export function refreshUserPhoneStatus() {
  if (!window.App || !window.App.currentUserId) {
    return $.Deferred().resolve()
  }

  return $.ajax(API.V3.userGet({ id: window.App.currentUserId }))
    .done((response) => {
      const meta = response.meta || {}
      const hasValidPhone = meta.validPhone === true
      const hasVerifiedPhone = meta.verifiedPhone === true

      window.App = window.App || {}
      window.App.userPhoneIsValid = hasValidPhone
      window.App.userPhoneVerified = hasVerifiedPhone
    })
}

export function needsPhoneVerificationOtp() {
  return coreUtils.userHasValidPhone() && !coreUtils.userHasVerifiedPhone()
}

export function needsPhoneVerificationGate() {
  return needsPhoneVerificationOtp() || !coreUtils.userHasValidPhone()
}

export function phoneVerificationGateOpensChangePhone() {
  return !coreUtils.userHasValidPhone()
}
